import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import HeroSection from '../features/landing/sections/HeroSection';
import PriceBandSection from '../features/landing/sections/PriceBandSection';
import FleetSection from '../features/landing/sections/FleetSection';
import ProductPreviewSection from '../features/landing/sections/ProductPreviewSection';
import HowItWorksSection from '../features/landing/sections/HowItWorksSection';
import BenefitsSection from '../features/landing/sections/BenefitsSection';
import CoverageSection from '../features/landing/sections/CoverageSection';
import WhoItsForSection from '../features/landing/sections/WhoItsForSection';
import HomeCtaSection from '../features/landing/sections/HomeCtaSection';
import WhatsAppFloatingAction from '../components/common/WhatsAppFloatingAction';

const LandingPage: React.FC = () => {
  return (
    <div className="landing-shell">
      <Header />
      {/* Section order is fixed by Redesign v2:
          Hero + estimate · How it works · Fleet · Benefits · Coverage ·
          Who it's for · On your phone · Final CTA.
          The price band is the one addition to that order — it carries the
          confirmed bakkie rate, derived from the rate card. */}
      <main>
        <HeroSection />
        <PriceBandSection />
        <HowItWorksSection />
        <FleetSection />
        <BenefitsSection />
        <CoverageSection />
        <WhoItsForSection />
        <ProductPreviewSection />
        <HomeCtaSection />
      </main>
      <WhatsAppFloatingAction />
      <Footer />
    </div>
  );
};

export default LandingPage;
